const RECEIPT_RANK = { sent: 0, delivered: 1, read: 2 };

export const mergeWhatsAppReactions = (previous = [], incoming = []) => {
  const byActor = new Map(previous.map(reaction => [reaction.actor, reaction]));
  incoming.forEach(reaction => {
    const old = byActor.get(reaction.actor);
    const newest =
      !old ||
      reaction.timestamp_ms > old.timestamp_ms ||
      (reaction.timestamp_ms === old.timestamp_ms &&
        reaction.event_id >= old.event_id);
    if (newest) byActor.set(reaction.actor, reaction);
  });
  return Array.from(byActor.values());
};

export const mergeMessageState = (previous, incoming) => {
  if (!previous || previous.id !== incoming.id) return incoming;
  const merged = {
    ...previous,
    ...incoming,
    content_attributes: {
      ...previous.content_attributes,
      ...incoming.content_attributes,
    },
    additional_attributes: {
      ...previous.additional_attributes,
      ...incoming.additional_attributes,
    },
  };
  if (
    previous.additional_attributes?.whatsapp_reactions ||
    incoming.additional_attributes?.whatsapp_reactions
  ) {
    merged.additional_attributes.whatsapp_reactions = mergeWhatsAppReactions(
      previous.additional_attributes?.whatsapp_reactions,
      incoming.additional_attributes?.whatsapp_reactions
    );
  }
  if (
    (previous.content_attributes?.whatsapp_edited_at || 0) >
    (incoming.content_attributes?.whatsapp_edited_at || 0)
  ) {
    merged.content = previous.content;
    merged.content_attributes = {
      ...merged.content_attributes,
      ...previous.content_attributes,
    };
  }
  // A late HTTP acknowledgement must not undo a delivery/read event received over cable.
  if (
    RECEIPT_RANK[previous.status] > 0 &&
    RECEIPT_RANK[previous.status] > (RECEIPT_RANK[incoming.status] ?? -1)
  ) {
    merged.status = previous.status;
    merged.source_id = previous.source_id || incoming.source_id;
  }
  return merged;
};

export const mergeMessageSnapshots = (loaded, snapshots) => {
  const byId = new Map(loaded.map(message => [message.id, message]));
  snapshots.forEach(message =>
    byId.set(message.id, mergeMessageState(byId.get(message.id), message))
  );
  return Array.from(byId.values()).sort(
    (first, second) => first.created_at - second.created_at
  );
};
